import { render, staticRenderFns } from "./AnnouncementPushEdit.vue?vue&type=template&id=72b24b56"
import script from "./AnnouncementPushEdit.vue?vue&type=script&lang=js"
export * from "./AnnouncementPushEdit.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementPushEdit.vue?vue&type=style&index=0&id=72b24b56&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports